import React, { ReactNode } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Spinner, { SpinnerSize } from '@divvy-web/skylab.spinner'

import BillBrandLogo from '@sputnik/components/BillBrandLogo'

import styles from './styles.module.scss'

interface PollingPageContentProps {
  mainText: ReactNode
  subText: ReactNode
  children?: ReactNode
}

const PollingPageContent = ({ mainText, subText, children }: PollingPageContentProps) => {
  const [getClassName] = useNameFormatter('PollingPageContent')

  return (
    <div className={styles[getClassName('')]}>
      <BillBrandLogo />
      <div className={styles[getClassName('main-content-section')]}>
        <div className={styles[getClassName('body-text')]}>
          <h1 className={styles[getClassName('title')]}>{mainText}</h1>
          <h2 className={styles[getClassName('subtitle')]}>{subText}</h2>
          <div className={styles[getClassName('spinner-and-text')]}>
            <Spinner size={SpinnerSize.Small} />
            <FormattedMessage
              defaultMessage='This can take up to a minute'
              id='sputnik.PollingPageContent__72Pvw0'
            />
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

export default PollingPageContent
